import setFingerprintOfPriorProducts from "./setFingerprintOfPriorProducts";
import setAdSpecificTargeting from "./setAdSpecificTargeting";

export default [setFingerprintOfPriorProducts, setAdSpecificTargeting];
